export default class FeeScheduleTag {
  public readonly value: string;

  public constructor(value: string) {
    this.value = value;
  }

  public isEqualTo(other: FeeScheduleTag | null | undefined): boolean {
    if(!other) return false;
    return this.value === other.value;
  }

  public static get Prototype(): FeeScheduleTag {
    return new FeeScheduleTag("Prototype Tag");
  }

  public fromJSON(value: string): FeeScheduleTag {
    return new FeeScheduleTag(value);
  }
  public toJSON(): string {
    return this.value;
  }
  public clone(): FeeScheduleTag {
    return new FeeScheduleTag(this.value);
  }
}
